import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SVGInline from 'react-svg-inline';
import chevronDown from 'legacy/assets/svg-inline/chevron_down.svg';
import chevronUp from 'legacy/assets/svg-inline/chevron_up.svg';

import { ChevronIcon as theme } from 'legacy/css-modules/generic';

export default class ChevronIcon extends PureComponent {
  static propTypes = {
    direction: PropTypes.string
  };
  static defaultProps = {
    direction: 'up'
  };

  render() {
    return (
      <SVGInline
        className={theme[`chevron-${this.props.direction}`]}
        svg={this.props.direction === 'up' ? chevronUp : chevronDown}
      />
    );
  }
}
